import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './Products.css';

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8002/api');

const Products = () => {
  const { user, trackVisit } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API_URL}/products`);
      setProducts(response.data.products || []);
      setError('');
    } catch (error) {
      console.error('Failed to fetch products:', error);
      setError('Failed to load products. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleAppClick = (productUrl) => {
    if (productUrl && user) {
      trackVisit(productUrl);
    }
  };

  if (loading) {
    return (
      <div className="products-page">
        <section className="section">
          <div className="container">
            <h1 className="section-title">Our Products</h1>
            <p className="section-subtitle">
              Explore our collection of innovative web applications
            </p>
            <div className="no-products">
              <p>Loading products...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="products-page">
      <section className="section">
        <div className="container">
          <h1 className="section-title">Our Products</h1>
          <p className="section-subtitle">
            Explore our collection of innovative web applications
          </p>

          {error && (
            <div className="alert alert-error" style={{ marginBottom: '20px' }}>
              {error}
            </div>
          )}

          <div className="products-grid">
            {products.map((product) => {
              const isComingSoon = product.status === 'coming soon';
              return (
                <div key={product.id} className="product-card card">
                  <div className="product-header">
                    <h3>{product.name}</h3>
                    {product.status && (
                      <span className={`badge ${product.status === 'live' ? 'badge-live' : 'badge-coming-soon'}`}>
                        {product.status === 'live' ? 'Live' : 'Coming Soon'}
                      </span>
                    )}
                  </div>
                  {product.image_url && (
                    <img 
                      src={product.image_url} 
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        marginBottom: '16px'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                  <p className="product-description">
                    {product.description || 'No description available.'}
                  </p>
                  {isComingSoon ? (
                    <button
                      className="btn btn-secondary"
                      disabled
                      style={{ cursor: 'not-allowed', opacity: 0.6 }}
                    >
                      Coming Soon
                    </button>
                  ) : (
                    <a
                      href={product.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => handleAppClick(product.url)}
                      className="btn btn-primary"
                    >
                      Visit Product
                    </a>
                  )}
                </div>
              );
            })}
          </div>

          {products.length === 0 && !error && (
            <div className="no-products">
              <p>More products coming soon!</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Products;

